export default __webpack_public_path__ + "static/media/qts.7e42abe6.png";